module.exports = __webpack_public_path__ + "static/img/2.2b0fde0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/eng/2.png
// module id = 07Sn
// module chunks = 0